import { useState } from 'react';

/**
 * Hook for managing OutOfCreditsModal state
 * Provides a simple interface for showing/hiding the modal
 */
export const useOutOfCreditsModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleBuyCredits = () => {
    // Default behavior - redirect to BigVu signup
    window.open('https://desk.bigvu.tv/welcome?utm_campaign=avatar_generator&utm_content=buy_credits&utm_medium=modal&utm_source=prompt2avatar', '_blank');
    closeModal();
  };

  return {
    isOpen,
    openModal,
    closeModal,
    handleBuyCredits
  };
};
